import React from "react"
import {
	Flex,
	Text,
	Accordion,
	Icon,
	Rte,
	IconTypes,
} from "@capioweb/ui-components"
import { XhtmlString } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { createMarkup } from "../../utils"
import { LocalesContext } from "../../context"
import { HEADER_HEIGHT_S, scale } from "@capioweb/ui-components/src"
import { sendAccordionClickDataLayerPush } from "../../utils/piwikPro"

export interface FaqAccordionBaseBlockItem {
	heading: StringProperty
	icon: StringProperty
	body: XhtmlString
	anchorId?: StringProperty
}

interface FaqAccordionItemProps extends FaqAccordionBaseBlockItem {
	hidden?: boolean
	setActiveId?: (id: string) => void
	activeId?: string
}

const FaqAccordionItem: React.FC<FaqAccordionItemProps> = (props) => {
	const { translate, translationKeys } = React.useContext(LocalesContext)
	const id = props.anchorId.value || props.heading.value

	const ref = React.useRef(null)

	const scrollToRef = () => {
		window.scrollTo(0, ref.current.offsetTop)
		setTimeout(() => {
			const headerOffset = scale(HEADER_HEIGHT_S) + 10
			const elementPosition = ref.current.getBoundingClientRect().top
			const offsetPosition = elementPosition + window.scrollY - headerOffset

			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth",
			})
		}, 100)
	}

	return (
		props.heading?.value && (
			<Flex
				ref={ref}
				id={id}
				w={1}
				flexDirection="column"
				display={props.hidden ? "none" : "flex"}
			>
				<Accordion.Header
					id={id}
					toggleLabel={`${translate(translationKeys.open)} ${
						props.heading.value
					}`}
					onClick={() => {
						props.setActiveId &&
							props.setActiveId(props.activeId === id ? null : id)
						scrollToRef()
						props.activeId !== id &&
							sendAccordionClickDataLayerPush(props.heading.value)
					}}
				>
					{props.icon.value && (
						<Flex>
							<Icon
								icon={props.icon.value as IconTypes}
								size={4.75}
								ml={-0.875}
								my={-0.5}
							/>
						</Flex>
					)}
					<Text
						as="h3"
						variant="headline-3"
						mb={0}
						pl={1}
						pr={4}
						ml={props.icon.value ? 0 : 3.875}
					>
						{props.heading?.value}
					</Text>
				</Accordion.Header>
				<Accordion.Panel id={id}>
					<Flex
						flexDirection="column"
						pt={3}
						pb={5}
						px={{ _: 2, m: 6.5, l: 7.5 }}
					>
						<Rte>
							{props.body.value && (
								<div dangerouslySetInnerHTML={createMarkup(props.body.value)} />
							)}
						</Rte>
					</Flex>
				</Accordion.Panel>
			</Flex>
		)
	)
}

export { FaqAccordionItem }
